import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-imageAdTypeShape",
  "use": "svg-icon-imageAdTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-imageAdTypeShape\"><g fill-rule=\"evenodd\"><path d=\"M0 4h16V1.999H0zm0 11h16v-2H0z\" /><path d=\"M0 14h2V1.999H0zm14 0h2V1.999h-2zM6.5 7a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 6.5 7\" /><path d=\"M16 13l-6-5-6 5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol